
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/anything-else",
      function () {
        return require("private-next-pages/support/anything-else/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/anything-else"])
      });
    }
  